import "./testimonials.css"
import React from "react"
// import Image from "gatsby-image"
import quotesImg from "../../assets/img/quotes.svg"
import { BgImage } from "gbimage-bridge"
// import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
// import SocialLinks from "../constants/socialLinks"
// ...GatsbyImageSharpFluid
import classNames from "classnames";
import { IoIosArrowBack } from "react-icons/io"
import { randomInteger } from "../../utils/utils"

const Testimonial = (props) => {
  const {
    allStrapiTestimonials: { nodes: testimonials },
  } = useStaticQuery(graphql`
    {
      allStrapiTestimonials {
        nodes {
          id
          strapiId
          text
          authorName
          authorImage {
            childImageSharp {
              gatsbyImageData(
                width: 400
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
          authorPosition
          authorCompany
          authorCompanyUrl
        }
      }
    }
  `)

  let [activeItem, setActiveItem] = React.useState(getIndexByStrapiId(props.selected) || randomInteger(0, testimonials.length-1));

  function getIndexByStrapiId(id) {
    let res = 0;
    for (let i=0; i<testimonials.length; i++){
      if (testimonials[i].strapiId === id) {
        res = i; 
        break;
      }
    }
    return res;
  }

  function testimonialsScrollRight() {
    setActiveItem(activeItem < testimonials.length - 1 ? activeItem + 1 : 0);
    // newsListRef.current.scrollBy(400, 0);
  }

  function testimonialsScrollLeft() {
    setActiveItem(activeItem ? activeItem - 1 : testimonials.length - 1);
    // newsListRef.current.scrollBy(-400, 0);
  }

  return (
    <div className={"gs-testimonials-list clean " + (props.className ? props.className : "") }>

        {testimonials.filter((item, index)=> index === activeItem).map((testimonial)=>{
          return (
            <article key={testimonial.id} className={classNames("gs-testimonials-item", "gs-animate--fadeInUp")}>
            {/* <BackgroundImage key={testimonial.id} fluid={testimonial.authorImage.childImageSharp.fluid} className="gs-testimonials-item__pic">
            </BackgroundImage> */}
                <div className="gs-testimonials-item-text">
                  <div className="gs-testimonials-item-quote mb2">
                  <div className="gs-testimonials-item-quote__icon"><img src={quotesImg} alt="Quotes"/></div>
                    {testimonial.text}
                  </div>
                  <div className="gs-testimonials-item-author fw300">
                      <BgImage key={testimonial.id} image={testimonial.authorImage.childImageSharp.gatsbyImageData} className="gs-testimonials-item-author-pic">
                      </BgImage>
                      <div className="gs-testimonials-item-author__text">
                        <div className="gs-testimonials-item-author-name">
                          <span className="gs-testimonials-item-author-name__dash">&mdash;&nbsp;</span>
                          <b>{testimonial.authorName}</b>
                        </div>
                        <div className="gs-testimonials-item-company">
                          <span>{testimonial.authorCompany}</span>
                          &nbsp;
                          <br />{testimonial.authorPosition}
                        </div>
                      </div>
                  </div>
                </div>
            </article>
          );
        })}
        <IoIosArrowBack className="gs-testimonials-list-arrow gs-color-yellow" onClick={testimonialsScrollLeft}/>
        <IoIosArrowBack className={classNames("gs-testimonials-list-arrow gs-color-yellow", "gs-testimonials-list-arrow--right")} onClick={testimonialsScrollRight}/>
    </div>
  );

}

export default Testimonial
